import React, { useState, useEffect } from "react";
import "../ViewStudent/ViewStudent.css";

function ViewStudent({ student, onClose }) {
  const [studentData, setStudentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log("ViewStudent received student:", student); // Debug: Log the student prop
    if (!student || !student.student_id) {
      setError("No valid student data provided.");
      setLoading(false);
      return;
    }

    // Use the provided student prop directly
    setStudentData(student);
    setLoading(false);
  }, [student]);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "Invalid Date";
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } catch {
      return "Invalid Date";
    }
  };

  // Handle missing student prop
  if (!student || !student.student_id) {
    return (
      <div className="view-container">
        <div className="view">
          <h2>No Student Data Available</h2>
          <p>Please provide valid student information.</p>
          <div className="view-actions">
            <button className="view-cancel" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Handle loading state
  if (loading) {
    return (
      <div className="view-container">
        <div className="view">
          <h2>Loading...</h2>
        </div>
      </div>
    );
  }

  // Handle error state
  if (error) {
    return (
      <div className="view-container">
        <div className="view">
          <h2>Error</h2>
          <p>{error}</p>
          <div className="view-actions">
            <button className="view-cancel" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Main render with student data
  return (
    <div className="view-container">
      <div className="view">
        <div className="view-header">
          <h2>Student Details</h2>
        </div>
        <div className="view-details">
          <p>
            <strong>Student ID:</strong> {studentData?.student_id || "N/A"}
          </p>
          <p>
            <strong>Name:</strong> {studentData?.student_name || "N/A"}
          </p>
          <p>
            <strong>Class:</strong> {studentData?.class || "N/A"}
          </p>
          <p>
            <strong>Section:</strong> {studentData?.section || "N/A"}
          </p>
          <p>
            <strong>Gender:</strong> {studentData?.gender || "N/A"}
          </p>
          <p>
            <strong>DOB:</strong> {formatDate(studentData?.dob)}
          </p>
          <p>
            <strong>Academic Year Joined:</strong>{" "}
            {studentData?.academic_year_joined || "N/A"}
          </p>
          <p>
            <strong>Address:</strong> {studentData?.address || "N/A"}
          </p>
          <p>
            <strong>Caste:</strong> {studentData?.caste || "N/A"}
          </p>
          <p>
            <strong>Blood Group:</strong> {studentData?.student_blood_group || "N/A"}
          </p>
          <p>
            <strong>Father Name:</strong> {studentData?.father_name || "N/A"}
          </p>
          <p>
            <strong>Mother Name:</strong> {studentData?.mother_name || "N/A"}
          </p>
        </div>
        <div className="view-actions">
          <button className="view-cancel" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewStudent;